import { SVGProps } from 'react';

import palette from '../../../theme/palette';
import { styleConfigs } from '../../resources/styleConfigs';

const CloudAlertIcon = ({
  width = styleConfigs.dimensions.width30,
  height = styleConfigs.dimensions.height30,
  fill = palette.light.text.prussianBlue,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 128 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M30.4167 91.25C22.0095 91.25 14.8383 88.3335 8.90296 82.5006C2.96765 76.6677 0 69.5391 0 61.1147C0 53.693 2.38264 47.0799 7.14792 41.2754C11.9132 35.4709 17.9925 32.0384 25.3857 30.9779C27.3355 21.8843 31.9081 14.4479 39.1037 8.66875C46.2982 2.88958 54.5553 0 63.875 0C74.8899 0 84.2339 3.83655 91.907 11.5097C99.5801 19.1828 103.417 28.5268 103.417 39.5417V42.5833H105.289C111.7 43.0822 117.046 45.66 121.328 50.3168C125.609 54.9726 127.75 60.5058 127.75 66.9167C127.75 73.7016 125.391 79.4534 120.672 84.1721C115.953 88.8907 110.202 91.25 103.417 91.25H30.4167ZM30.4167 82.125H103.417C107.675 82.125 111.274 80.6549 114.215 77.7146C117.155 74.7743 118.625 71.175 118.625 66.9167C118.625 62.6583 117.155 59.059 114.215 56.1188C111.274 53.1785 107.675 51.7083 103.417 51.7083H94.2917V39.5417C94.2917 31.1264 91.326 23.9531 85.3948 18.0219C79.4635 12.0906 72.2903 9.125 63.875 9.125C55.4597 9.125 48.2865 12.0906 42.3552 18.0219C36.424 23.9531 33.4583 31.1264 33.4583 39.5417H30.4167C24.5361 39.5417 19.5174 41.6201 15.3604 45.7771C11.2035 49.934 9.125 54.9528 9.125 60.8333C9.125 66.7139 11.2035 71.7326 15.3604 75.8896C19.5174 80.0465 24.5361 82.125 30.4167 82.125ZM67.1265 65.5464C68.0005 64.6714 68.4375 63.5871 68.4375 62.2933C68.4375 61.0006 68 59.9173 67.125 59.0433C66.25 58.1704 65.1662 57.7339 63.8735 57.7339C62.5798 57.7339 61.4964 58.1709 60.6235 59.0448C59.7495 59.9198 59.3125 61.0042 59.3125 62.2979C59.3125 63.5906 59.75 64.6739 60.625 65.5479C61.5 66.4209 62.5838 66.8574 63.8765 66.8574C65.1702 66.8574 66.2536 66.4204 67.1265 65.5464ZM59.3125 48.6089H68.4375V22.8125H59.3125V48.6089Z"
      fill={fill}
    />
  </svg>
);

export default CloudAlertIcon;
